import { render, staticRenderFns } from "./TxView.vue?vue&type=template&id=51602df4&scoped=true&"
import script from "./TxView.vue?vue&type=script&lang=js&"
export * from "./TxView.vue?vue&type=script&lang=js&"
import style0 from "./TxView.vue?vue&type=style&index=0&id=51602df4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51602df4",
  null
  
)

export default component.exports